import { Component, Inject, ViewChild } from '@angular/core';
import { NgModel } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogBase, ObjectTypeInfo } from 't4core';
import { LocationUserInfo } from 't4core';
import { ProductType, Additive } from 't4core';
import { T4DatatableWidget } from '../../../../t4common';
import { OneWayAdmin } from '../../../OneWayAdmin/owadmin.module';
import { RentalObjectInfo } from '../../../../../projects/t4core/src/public-api';

@Component({
  styleUrls: ['CreateObjectDialog.css'],
  selector: 'CreateObjectDialog',
  templateUrl: 'CreateObjectDialog.html',
})
export class CreateObjectDialog extends DialogBase {
  public objectToSave: RentalObjectInfo;
  public objectTypes: ObjectTypeInfo[];
  public filteredObjectTypes: ObjectTypeInfo[];
  public searchText: string = '';
  @ViewChild("tblContent") private tblContent: T4DatatableWidget;
  public isLoading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<CreateObjectDialog>,
    @Inject(MAT_DIALOG_DATA) public data: { editable: boolean, objectToChange: RentalObjectInfo }
  ) {
    super("CreateObjectDialog");
  }

  public async ngOnInit() {
    this.isLoading = true;
    if (this.data.objectToChange) {
      this.objectToSave = this.data.objectToChange;
    }
    else {
      this.objectToSave = new RentalObjectInfo;
      this.objectToSave.IsManual = true;
    }

    await this.getObjectTypes();
    this.isLoading = false;
    //if (this.objectToSave.Id) {
    //    this.getCategories(this.objectToSave.Id);
    //}
    //else {
    //    this.getCategories();
    //}
  }

  public async getObjectTypes() {
    this.objectTypes = await this.Api.get<ObjectTypeInfo[]>("RentalObject/GetAllTypes", { type: 0, requirePrefix: true });
    this.objectTypes = this.objectTypes.sort((x, y) => x.Title < y.Title ? -1 : 1);
    this.filteredObjectTypes = this.objectTypes;
    if (!this.objectToSave.Type) this.objectToSave.Type = this.objectTypes[0];
  }

  public toggleAvailability(event) {
    this.objectToSave.IsEnabled = event.checked;
  }

  public toggleOnlineAvailability(event) {
    this.objectToSave.AvailableOnline = event.checked;
  }

  public async save() {

    var token = this.beginLoad("T4.Settings.SaveObjectDialog.msgCreating", "Saving object", null);

    var saved = await this.Api.post<boolean>("RentalObject/SaveObject", this.objectToSave, { availableOnline: this.objectToSave.AvailableOnline ? this.objectToSave.AvailableOnline : false });
    this.endLoad(token);
    if (saved) {
      this.dialogRef.close(true);
    }
    else {
      alert("Failed, try again!");
    }
  }

  public setType(event) {
    this.objectToSave.Type = event.value;
  }

  public filterTypes() {
    this.filteredObjectTypes = this.objectTypes.filter(type => type.Title.toLowerCase().includes(this.searchText.toLowerCase()));
  }

  public resetSearch(opened: boolean) {
    if (!opened) {
      this.searchText = '';
      this.filteredObjectTypes = this.objectTypes;
    }
  }
}
